module.exports = __webpack_public_path__ + "static/img/markers.8bef698d.png";